/*
 * Copyright 2024, Corning Optical Communications
 * All Rights Reserved.
 */

export interface IDasInventoryFilterState {
  selectedEquipmentType?: string;
  selectedStatus?: string;
  selectedBand?: string;
  searchText?: string;
}

export const initialDasInventoryFilterState: IDasInventoryFilterState = {
  selectedEquipmentType: "",
  selectedStatus: "",
  selectedBand: "",
  searchText: "",
};
